export const DEFAULT_FILTER = { KEY_BUSINESS_SYSTEM: { KEY_BUSINESS_SYSTEM_CHECKBOX: ['MAJOR', 'NONE'] } };

export const DEFAULT_SORT = 'thirdparty.securityScore:ASC';

export const PAGE_THRESHOLD = 10;
